var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_110_6637)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.9375 0H6.0625C2.71427 0 0 2.71427 0 6.0625V90.9375C0 94.2857 2.71427 97 6.0625 97H90.9375C94.2857 97 97 94.2857 97 90.9375V6.0625C97 2.71427 94.2857 0 90.9375 0Z",
    fill: "url(#paint0_linear_110_6637)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.4375 18.1875H21.0126C19.4546 18.1875 18.1875 19.4061 18.1875 20.9156V63.9594C18.1875 65.4629 19.4546 66.6875 21.0126 66.6875H42.4375C55.8296 66.6875 66.6875 55.8296 66.6875 42.4375C66.6875 29.0454 55.8296 18.1875 42.4375 18.1875Z",
    fill: "url(#paint1_linear_110_6637)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.5625 30.3125H33.1376C31.5796 30.3125 30.3125 31.5311 30.3125 33.0406V76.0844C30.3125 77.5879 31.5796 78.8125 33.1376 78.8125H54.5625C67.9546 78.8125 78.8125 67.9546 78.8125 54.5625C78.8125 41.1704 67.9546 30.3125 54.5625 30.3125Z",
    fill: "url(#paint2_linear_110_6637)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5625 30.3123C67.9546 30.3123 78.8125 41.1702 78.8125 54.5623C78.8125 67.9544 67.9546 78.8123 54.5625 78.8123H33.1376C31.5796 78.8123 30.3125 77.5937 30.3125 76.0842V33.0404C30.3125 31.5369 31.5796 30.3123 33.1376 30.3123H54.5625ZM54.5625 29.7061H33.1376C31.2461 29.7061 29.7062 31.2035 29.7062 33.0404V76.0842C29.7062 77.9211 31.2461 79.4186 33.1376 79.4186H54.5625C68.2698 79.4186 79.4187 68.2696 79.4187 54.5623C79.4187 40.855 68.2698 29.7061 54.5625 29.7061Z",
    fill: "url(#paint3_linear_110_6637)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_110_6637",
    x1: 0,
    y1: 48.5,
    x2: 97,
    y2: 48.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2941A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F1901A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EE7D1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE771D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_110_6637",
    x1: 13.6042,
    y1: 19.8971,
    x2: 51.3373,
    y2: 57.6301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#1B1919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0A0606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#040000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_110_6637",
    x1: 71.1798,
    y1: 91.2103,
    x2: 39.9519,
    y2: 37.1207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_110_6637",
    x1: 63.5774,
    y1: 78.0545,
    x2: 34.7987,
    y2: 28.2026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_110_6637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 97,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footerLogo.9069be72b258117649b05248e6fc2b2b.svg";
export { ForwardRef as ReactComponent };